export default "<router-outlet></router-outlet>\n<ng-snotify></ng-snotify>\n"